import {
  GETANNEXOVERVIEW,
  GETAUDITLOGGRID,
  GETEXERCISEGRID,
  GETPARTYGRID,
  GETREQUESTEDSERVICES,
  GETSORGRID,
  GETUSERGRID,
  GET_ACTIVITY_GRID,
  GET_CATALOG_GRID,
  GET_ORDER_GRID,
  GET_GROUP_GRID,
  GET_TICKET_GRID
} from '@hobs/constants/gridSelections';
import { actionCreator } from './utils/utils';

export const getAnnexOverviewGrid = () =>
  actionCreator('GridSelections/AnnexOverview', GETANNEXOVERVIEW);
export const getAuditLogGrid = () =>
  actionCreator('GridSelections/AuditLogGrid', GETAUDITLOGGRID);
export const getExerciseGrid = () =>
  actionCreator('GridSelections/ExerciseGrid', GETEXERCISEGRID);
export const getPartyGrid = () =>
  actionCreator('GridSelections/PartyGrid', GETPARTYGRID);
export const getRequestedServicesGrid = (partyId) =>
  actionCreator(`GridSelections/RequestedServices/${partyId}`, GETREQUESTEDSERVICES);
export const getSorGrid = () =>
  actionCreator('GridSelections/SorGrid', GETSORGRID);
export const getUserGrid = partyId => {
  return actionCreator(
    partyId ? `GridSelections/UserGrid/${partyId}` : 'GridSelections/UserGrid',
    GETUSERGRID
  );
};
export const getAllUserGrid = () => {
  return actionCreator(
    'GridSelections/UserGrid',
    GETUSERGRID
  );
};
export const getCatalogGrid = () =>
  actionCreator('GridSelections/CatalogGrid', GET_CATALOG_GRID);
export const getActivityGrid = () =>
  actionCreator('GridSelections/ActivityGrid', GET_ACTIVITY_GRID);
export const getOrderGrid = () =>
  actionCreator('GridSelections/OrderManagementGrid', GET_ORDER_GRID);
export const getGroupGrid = () =>
  actionCreator('GridSelections/GroupGrid', GET_GROUP_GRID);
export const getTicketGrid = () =>
  actionCreator('GridSelections/TicketsGrid', GET_TICKET_GRID);
